import { render, staticRenderFns } from "./expertLect.vue?vue&type=template&id=15e1d1e3&scoped=true&"
import script from "./expertLect.vue?vue&type=script&lang=js&"
export * from "./expertLect.vue?vue&type=script&lang=js&"
import style0 from "./expertLect.vue?vue&type=style&index=0&id=15e1d1e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e1d1e3",
  null
  
)

export default component.exports